import { render } from "./MensNonnoApp.vue?vue&type=template&id=0724dcd2&ts=true"
import script from "./MensNonnoApp.vue?vue&type=script&lang=ts"
export * from "./MensNonnoApp.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4045154729/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__